module.exports = __webpack_public_path__ + "static/media/check.ae4c41e8.svg";